declare namespace $ {

	type $mol_view__sub_bog_ui_app_table_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_table_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_table__columns_bog_ui_app_table_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app_table['columns'] >
		,
		ReturnType< $bog_ui_table['columns'] >
	>
	type $bog_ui_table__data_bog_ui_app_table_4 = $mol_type_enforce<
		ReturnType< $bog_ui_app_table['data'] >
		,
		ReturnType< $bog_ui_table['data'] >
	>
	type $bog_ui_table__selectable_bog_ui_app_table_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $bog_ui_table['selectable'] >
	>
	type $bog_ui_table__selected_bog_ui_app_table_6 = $mol_type_enforce<
		ReturnType< $bog_ui_app_table['selected'] >
		,
		ReturnType< $bog_ui_table['selected'] >
	>
	type $bog_ui_table__sort_column_bog_ui_app_table_7 = $mol_type_enforce<
		ReturnType< $bog_ui_app_table['sort_column'] >
		,
		ReturnType< $bog_ui_table['sort_column'] >
	>
	type $bog_ui_table__sort_dir_bog_ui_app_table_8 = $mol_type_enforce<
		ReturnType< $bog_ui_app_table['sort_dir'] >
		,
		ReturnType< $bog_ui_table['sort_dir'] >
	>
	export class $bog_ui_app_table extends $mol_page {
		description( ): string
		Description( ): $mol_view
		selected_text( ): string
		Selected_info( ): $mol_view
		columns( ): readonly(any)[]
		data( ): readonly(any)[]
		selected( next?: readonly(any)[] ): readonly(any)[]
		sort_column( next?: string ): string
		sort_dir( next?: string ): string
		Table( ): $bog_ui_table
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map